import img9 from '../.././Image/img9.jpg'
import img5 from '../.././Image/img5.PNG'
import img7 from '../.././Image/img7.PNG'
import img15 from '../.././Image/IMG_3186.PNG'



function Ui() {
    return (
        <>
            <div className="inline-grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 justify-center place-items-center">

                <div className="overflow-hidden rounded-lg shadow-lg hover:shadow-xl transition-shadow w-[300px] h-[300px]">
                    <img
                        src={img15}
                        className="w-full h-full object-cover transition-transform duration-500 hover:scale-105"
                    />
                </div>

                <div className="overflow-hidden rounded-lg shadow-lg hover:shadow-xl transition-shadow w-[300px] h-[300px]">
                    <img
                        src={img5}
                        className="w-full h-full object-cover transition-transform duration-500 hover:scale-105"
                    />
                </div>

                <div className="overflow-hidden rounded-lg shadow-lg hover:shadow-xl transition-shadow w-[300px] h-[300px]">
                    <img
                        src={img7}
                        className="w-full h-full object-cover transition-transform duration-500 hover:scale-105"
                    />
                </div>

  <div className="rounded-lg overflow-hidden shadow-lg hover:shadow-xl transition-all duration-500 w-[300px] h-[300px]">
                    <img src={img9} className="w-full h-full object-cover transition-transform duration-500 hover:scale-105" />
                </div>
            </div>


            <div className="text-white mx-4 sm:mx-10 md:mx-[80px] font-sans leading-relaxed mt-10 sm:mt-14 md:mt-16">

               <h1 className="text-center text-2xl sm:text-3xl md:text-4xl font-extrabold mb-10 sm:mb-14 md:mb-16 
                    bg-gradient-to-r from-purple-400 to-blue-400 text-transparent bg-clip-text">
                    Design Documentation
                </h1>

                <div className="inline-grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-10">


                    <div className="p-6 sm:p-8 rounded-2xl bg-white/10 backdrop-blur-xl shadow-lg 
                     hover:scale-[1.02] transition duration-300 border border-white/10 w-full max-w-[450px]">

                        <h2 className="text-xl sm:text-2xl md:text-3xl font-semibold text-purple-300">
                            UI/UX Structure Guide
                        </h2>
                        <p className="text-base sm:text-lg md:text-xl mt-2 text-gray-200 leading-relaxed">
                            A document outlining the complete structure of the user experience —
                            screen flows, navigation patterns, information hierarchy, user journeys,
                            and interaction models.
                        </p>
                    </div>

                    <div className="p-6 sm:p-8 rounded-2xl bg-white/10 backdrop-blur-xl shadow-lg 
                         hover:scale-[1.02] transition duration-300 border border-white/10 w-full max-w-[450px]">

                        <h2 className="text-xl sm:text-2xl md:text-3xl font-semibold text-purple-300">
                            UI/UX Content Guidelines
                        </h2>
                        <p className="text-base sm:text-lg md:text-xl mt-2 text-gray-200 leading-relaxed">
                            Formal rules for writing UI text — labels, microcopy, tooltips, onboarding
                            text, empty states, and notification messages for clarity and communication.
                        </p>
                    </div>

                    <div className="p-6 sm:p-8 rounded-2xl bg-white/10 backdrop-blur-xl shadow-lg 
                         hover:scale-[1.02] transition duration-300 border border-white/10 w-full max-w-[450px]">

                        <h2 className="text-xl sm:text-2xl md:text-3xl font-semibold text-purple-300">
                            UI/UX Design Framework
                        </h2>
                        <p className="text-base sm:text-lg md:text-xl mt-2 text-gray-200 leading-relaxed">
                            Detailed instructions on grids, spacing, colors, typography, buttons, forms,
                            input controls, cards, and layout principles across the interface.
                        </p>
                    </div>

                    <div className="p-6 sm:p-8 rounded-2xl bg-white/10 backdrop-blur-xl shadow-lg 
                     hover:scale-[1.02] transition duration-300 border border-white/10 w-full max-w-[450px]">

                        <h2 className="text-xl sm:text-2xl md:text-3xl font-semibold text-purple-300">
                            UI/UX Style Guide
                        </h2>
                        <p className="text-base sm:text-lg md:text-xl mt-2 text-gray-200 leading-relaxed">
                            Defines the interface’s visual and interaction style — tone, iconography,
                            motion rules, typography scales, and do’s & don’ts for clean UI.
                        </p>
                    </div>

                    <div className="p-6 sm:p-8 rounded-2xl bg-white/10 backdrop-blur-xl shadow-lg 
                     hover:scale-[1.02] transition duration-300 border border-white/10 w-full max-w-[450px]">

                        <h2 className="text-xl sm:text-2xl md:text-3xl font-semibold text-purple-300">
                            UI/UX Standards Manual
                        </h2>
                        <p className="text-base sm:text-lg md:text-xl mt-2 text-gray-200 leading-relaxed">
                            A complete guide for digital experiences — interaction patterns, usability
                            rules, gestures, transitions, animations, and accessibility standards.
                        </p>
                    </div>

                    <div className="p-6 sm:p-8 rounded-2xl bg-white/10 backdrop-blur-xl shadow-lg 
                     hover:scale-[1.02] transition duration-300 border border-white/10 w-full max-w-[450px]">

                        <h2 className="text-xl sm:text-2xl md:text-3xl font-semibold text-purple-300">
                            UI/UX Experience Handbook
                        </h2>
                        <p className="text-base sm:text-lg md:text-xl mt-2 text-gray-200 leading-relaxed">
                            A compact overview of user experience workflows, behavior patterns,
                            feedback systems, user needs, emotional design, and UX principles.
                        </p>
                    </div>

                    <div className="p-6 sm:p-8 rounded-2xl bg-white/10 backdrop-blur-xl shadow-lg 
                         hover:scale-[1.02] transition duration-300 border border-white/10 w-full max-w-[450px]">

                        <h2 className="text-xl sm:text-2xl md:text-3xl font-semibold text-purple-300">
                            UI/UX Component Library
                        </h2>
                        <p className="text-base sm:text-lg md:text-xl mt-2 text-gray-200 leading-relaxed">
                            A reusable collection of UI components — buttons, cards, lists, forms,
                            tabs, alerts, modals, navigation elements, and interactive controls.
                        </p>
                    </div>

                     <div className="p-6 sm:p-8 rounded-2xl bg-white/10 backdrop-blur-xl shadow-lg 
                     hover:scale-[1.02] transition duration-300 border border-white/10 w-full max-w-[450px]">

                        <h2 className="text-xl sm:text-2xl md:text-3xl font-semibold text-purple-300">
                            UI/UX Identity Manual
                        </h2>
                        <p className="text-base sm:text-lg md:text-xl mt-2 text-gray-200 leading-relaxed">
                            Explains the identity of the interface — templates, screen styles, icons,
                            spacing, imagery, and consistent behavior across the entire UI.
                        </p>
                    </div>

                    <div className="p-6 sm:p-8 rounded-2xl bg-white/10 backdrop-blur-xl shadow-lg 
                         hover:scale-[1.02] transition duration-300 border border-white/10 w-full max-w-[450px]">

                        <h2 className="text-xl sm:text-2xl md:text-3xl font-semibold text-purple-300">
                            UI/UX Design System & Identity
                        </h2>
                        <p className="text-base sm:text-lg md:text-xl mt-2 text-gray-200 leading-relaxed">
                            A unified system combining UI/UX principles with scalable design system
                            components supporting product and digital platform development.
                        </p>
                    </div>

                    <div className="p-6 sm:p-8 rounded-2xl bg-white/10 backdrop-blur-xl shadow-lg 
                     hover:scale-[1.02] transition duration-300 border border-white/10 w-full max-w-[450px]">

                        <h2 className="text-xl sm:text-2xl md:text-3xl font-semibold text-purple-300">
                            UI/UX Strategy Guide
                        </h2>
                        <p className="text-base sm:text-lg md:text-xl mt-2 text-gray-200 leading-relaxed">
                            A strategic document outlining UX goals, research insights, personas,
                            journey maps, feature priorities, and long-term experience roadmap.
                        </p>
                    </div>

                </div>

            </div>
        </>
    );
}

export default Ui;